// extracted by mini-css-extract-plugin
export var modalFooter = "_q5-0";